<template>
  <div class="big">
    <el-dialog
      :title="title"
      :visible.sync="poster"
      width="400px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div class="dialog">
        <div>
          <span style="color: red;margin-right:5px">*</span>
          <span>分类名称</span>
          <el-input
            v-model="category_data.category_name"
            style="width:200px;margin-left:8px"
          ></el-input>
        </div>
        <div style="padding-left:10px;margin:10px 0 20px">
          <span>上级分类</span>
          <el-select
            v-model="category_data.pid"
            placeholder="请选择"
            style="width:200px;margin-left:8px"
          >
            <el-option
              v-for="item in first_list"
              :key="item.category_id"
              :label="item.category_name"
              :value="item.category_id"
            >
            </el-option>
          </el-select>
        </div>
        <div style="text-align:center">
          <el-button
            plain
            size="medium"
            @click="poster=false"
          >取消</el-button>
          <el-button
            type="primary"
            size="medium"
            @click="savePoster"
          >确定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="page_title">分享处方海报模板</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="text-align:left;margin-bottom:20px">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addPoster"
            :disabled="
                module_id_array[0] ? !module_id_array.includes('774') : false
              "
          >新增模板分类</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            :data="tableData"
            style="width: 100%; min-width: 1000px"
            row-key="category_id"
            default-expand-all
            :tree-props="{children: 'list'}"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="category_name"
              label="分类名称"
            >
            </el-table-column>
            <el-table-column label="上传模板">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.category_poster"
                  class="align-center"
                >
                  <el-image
                    style="width: 100px;"
                    :src="scope.row.category_poster"
                    :preview-src-list="[scope.row.category_poster]"
                  >
                  </el-image>
                  <el-button
                    slot="trigger"
                    type="text"
                    style="margin-left:10px"
                    @click="delImg(scope.row.category_id)"
                    :disabled="module_id_array[0] ? !module_id_array.includes('776') : false"
                  >删除</el-button>
                </div>
                <el-upload
                  v-else
                  name="image"
                  accept=".png,.jpeg,.jpg"
                  :show-file-list="false"
                  :http-request="
                  (params) => {
                    uploadImg(params, scope.row);
                  }
                "
                  action="category_pic"
                >
                  <el-button
                    slot="trigger"
                    type="text"
                    :disabled="module_id_array[0] ? !module_id_array.includes('775') : false"
                  >上传图片</el-button>
                </el-upload>

              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="调整顺序"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="setSort(2,scope.row.category_id)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('777') : false"
                >上移</el-button>
                <el-button
                  type="text"
                  @click="setSort(3,scope.row.category_id)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('777') : false"
                >下移</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="是否启用"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_visible"
                  active-color="#669961"
                  :active-value="1"
                  :inactive-value="0"
                  @change="value=>{return updateStatus(value,scope.row.category_id)}"
                  :disabled="module_id_array[0] ? !module_id_array.includes('778') : false"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="editTemplate(scope.row)"
                  :disabled="
                module_id_array[0] ? !module_id_array.includes('774') : false
              "
                >编辑</el-button>
                <el-button
                  type="text"
                  @click="delPoster(scope.row)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('779') : false"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { uploadImg, getImgUrl } from '../../../service/common/constant';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      keyword: '',
      templateId: '',
      tcm_template_status: 1,
      poster: false,
      template_info: {},
      title: '新增分类',
      first_list: [],
      category_data: {
        category_id: '',
        category_name: '',
        pid: ''
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      this.axios
        .post('platform/prescription/getTcmCategoryList')
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
            this.first_list = res.data.list.map((item) => {
              item = _.pick(item, ['category_id', 'category_name']);
              return item;
            });
          }
        });
    },
    //新增模板
    addPoster() {
      this.title = '新增分类';
      this.category_data = {
        category_id: '',
        category_name: '',
        pid: ''
      };
      this.poster = true;
    },
    //编辑模板
    editTemplate(row) {
      this.title = '编辑分类';
      this.category_data = {
        category_id: row.category_id,
        category_name: row.category_name,
        pid: row.pid || ''
      };
      this.poster = true;
    },
    //保存海报模板
    savePoster() {
      if (!this.category_data.category_name) {
        this.$message.error('请填写分类名称');
        return false;
      }
      let data = this.category_data;
      this.axios
        .post('platform/prescription/saveTcmCategoryInfo', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.poster = false;
            this.getList();
          }
        });
    },
    //上传图片
    uploadImg(params, row) {
      let loading = this.$loading();
      let file = params.file;
      uploadImg(file).then((res) => {
        let data = {
          category_id: row.category_id,
          category_poster: res.data.pic
        };
        this.axios
          .post('platform/prescription/uploadTcmCategoryPoster', data)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('上传成功');
              this.getList();
              loading.close();
            }
          });
      });
    },
    //删除图片
    delImg(category_id) {
      this.axios
        .post('platform/prescription/deleteTcmCategoryPoster', { category_id })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功');
            this.getList();
          }
        });
    },
    //排序
    setSort(sort, category_id) {
      let data = {
        sort,
        category_id
      };
      this.axios
        .post('platform/prescription/editTcmCategorySort', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功');
            this.getList();
          }
        });
    },
    //更改海报模板状态
    updateStatus(is_visible, category_id) {
      let data = {
        is_visible,
        category_id
      };
      this.axios
        .post('platform/prescription/editTcmCategoryState', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功');
            this.getList();
          }
        });
    },
    //删除分类
    delPoster(row) {
      if (row.list && row.list.length) {
        this.$message.error('存在下级分类，不可删除!');
        return false;
      }
      this.$confirm('是否删除该分类？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let category_id = row.category_id;
          this.axios
            .post('platform/prescription/deleteTcmCategoryInfo', {
              category_id
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.addbox {
  text-align: left;
  padding: 20px;
}
.infobox {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /*超出3行部分显示省略号，去掉该属性 显示全部*/
  -webkit-box-orient: vertical;
}
.dialog {
  padding: 20px;
  box-sizing: border-box;
}
.itembox {
  display: flex;
  color: #000;
  flex-wrap: wrap;
  .item {
    width: 160px;
    display: flex;
    justify-content: space-between;
    margin-right: 30px;
    position: relative;
    margin-bottom: 20px;
  }
  .item::before {
    content: '';
    position: absolute;
    height: 12px;
    width: 1px;
    background: #d7d7d7;
    left: 170px;
    top: 4px;
  }
}
</style>
